export default __webpack_public_path__ + "static/media/new_gif.8b5eb6b6.gif";